import { TOKEN_COOKIE_KEY } from '@/constant/storage';
import Cookies from 'js-cookie';

// 清除cookie
export const clearCookie = () => {
  const cache = Cookies.get();
  if (cache && Object.keys(cache)?.length) {
    const host = window.location.host;
    const targetDomain = host?.split('.')?.slice(1)?.join('.');
    Cookies.remove(TOKEN_COOKIE_KEY, { path: '/', domain: targetDomain });
    Cookies.remove(TOKEN_COOKIE_KEY, { path: '/', domain: `.${targetDomain}` });
    Cookies.remove(TOKEN_COOKIE_KEY, { path: '/', domain: '' });
    Cookies.remove(TOKEN_COOKIE_KEY, { path: '/', domain: host });
    Cookies.remove('opendatalab_session', { path: '/', domain: host });
    Cookies.remove('opendatalab_session', { path: '/', domain: `.${host}` });
    Cookies.remove(TOKEN_COOKIE_KEY, { path: '/', domain: `.${host}` });
  }
};
